import request from "./base";
const path = "/api/scenarios";
const configPath = "/api/scenario-config";

export default {
  list: function () {
    return request().get(path + "/");
  },
  getConfigById: function (scenarioId) {
    return request().get(configPath + "/" + scenarioId);
  },
  setConfig: function (params) {
    return request().post(configPath + "/", params);
  },
};
